import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@altimateai/lego";

interface TimeFrameSelectorDropdownProps {
  options: Array<{ label: string; value: number }>;
  period: number;
  setPeriod: (value: number) => void;
}

const TimeFrameSelectorDropdown = ({ options, period, setPeriod }: TimeFrameSelectorDropdownProps) => {
  return (
    <Select value={String(period)} onValueChange={(value) => setPeriod(Number(value))}>
      <SelectTrigger className="al-w-[150px] al-bg-white al-text-brand" aria-label="Period">
        <SelectValue placeholder="Select a time period" />
      </SelectTrigger>
      <SelectContent>
        {options.map(op => {
          return (
            <SelectItem key={op.value} value={String(op.value)}>
              <span>{op.label}</span>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
};

export default TimeFrameSelectorDropdown;